import * as Icons from 'tabler-icons-react';
import HkBadge from '../../components/@hk-badge/@hk-badge';


export const NavMenu = [
    // {
    //     group: '',
    //     contents: [
    //         {
    //             name: 'Dashboard',
    //             icon: <Icons.Template />,
    //             path: '/dashboard',
    //             badge: <HkBadge size="sm" bg="pink" soft className="ms-xl-2 ms-auto" >hot</HkBadge>
    //         },
    //     ]
    // },
    {
        group: 'Apps',
        contents: [
            {
                id: 'dash_suppliers',
                name: 'Suppliers',
                icon: <Icons.Truck />,
                path: '/Suppliers',
                childrens: [
                    {
                        name: 'Suppliers Home',
                        path: '/Suppliers',
                        grp_name: "suppliers",
                    },
                    {
                        divider: true,
                    },
                    {
                        name: 'Supplier Search',
                        path: '/suppliers/search',
                        grp_name: "suppliers", // This is used to group the sub-menu items under the Suppliers section
                    },
                    {
                        name: 'Saved Supplier Searches',
                        path: '/suppliers/savedsearches',
                        grp_name: "suppliers",
                    },
                    {
                        name: 'My Suppliers',
                        path: '/suppliers/my-suppliers',
                        grp_name: "suppliers",
                    },
                    // {
                    //     name: 'Supplier Search (Vector)',
                    //     path: '/suppliers/search?endpoint=vector',
                    //     grp_name: "suppliers", // Vector Search endpoint
                    // },
                    // {
                    //     name: 'Supplier Search (OpenSearch)',
                    //     path: '/suppliers/search?endpoint=opensearch',
                    //     grp_name: "suppliers", // OpenSearch endpoint
                    // },
                    // {
                    //     name: 'Saved Supplier Searches',
                    //     path: '/suppliers/supplier-search/saved-searches',
                    //     grp_name: "suppliers", // This is used to group the sub-menu items under the Suppliers section
                    // },
                    {
                        name: 'Sourcing Projects',
                        path: '/projects/sourcing/detail',
                        grp_name: "suppliers", // This is used to group the sub-menu items under the Suppliers section
                    },
                    {
                        divider: true,
                    },
                    {
                        name: 'Create New Supplier',
                        path: '/suppliers/create',
                        grp_name: "suppliers",
                    },
                    // {
                    //     name: 'Supplier Repository',
                    //     path: '/suppliers/repository',
                    //     grp_name: "suppliers", // This is used to group the sub-menu items under the Suppliers section
                    // },
                ]
            },
            {
                id: 'dash_opportunities',
                name: 'Opportunities',
                icon: <Icons.CurrencyDollar />,
                path: '/opportunities/reset',
                childrens: [
                    {
                        name: 'Opportunity Search',
                        path: '/opportunities/reset',
                        grp_name: "opportunities", // This is used to group the sub-menu items under the Opportunities section
                    },
                    {
                        name: 'Saved Opportunity Searches',
                        path: '/opportunities/savedsearches',
                        grp_name: "opportunities", // This is used to group the sub-menu items under the Opportunities section
                    },
                    {
                        name: 'Opportunity Projects',
                        path: '/projects/opportunities/cards',
                        grp_name: "opportunities", // This is used to group the sub-menu items under the Opportunities section
                    },
                    {
                        name: 'Opportunity Projects (LIST VIEW)',
                        path: '/projects/opportunities/listview',
                        grp_name: "opportunities", // This is used to group the sub-menu items under the Opportunities section
                    },
                ]
            },

        ]
    },

]